import React from "react";

import {FlexGrid, FlexGridItem} from "components/base/FlexGrid";
import {debounce, hasErrorObject} from "utils";

import { Form, Input, Schema } from "rsuite";

const {StringType} = Schema.Types;

const model = Schema.Model({
    str: StringType()
        .maxLength(255, "The maximum is only 255 characters.")
});


export default ({
    defaultFilter,
    onChangeFilter
}) => {

    return (
        <>
            <Form
                model={model}
                formDefaultValue={defaultFilter}
                onChange={debounce((formValue) => {
                    const formCheckData = model.check(formValue);
                    if (!hasErrorObject(formCheckData)) {
                        onChangeFilter(formValue);
                    }
                }, 500)}
            >
                <FlexGrid align="middle">
                    <FlexGridItem>
                        <Form.Control
                            accepter={Input}
                            name="str"
                            placeholder="Prefix/Dialer..."
                            style={{width: 300}}
                        />
                    </FlexGridItem>
                </FlexGrid>
            </Form>
        </>
    )
};
